export default (texto) => {
	if (texto) return texto
	return 'Sem Processo'
}
